import "./App.css";
import Navbar from "./Components/Navbar";
import News from "./Components/News";
import React from "react";
import LoadingBar from "react-top-loading-bar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

const App = () => {
  const apiKey = process.env.REACT_APP_NEWS_API;
  const [progress, setprogress] = useState(10);

  const setProgress = (Progress) => {
    setprogress(Progress);
  };

  return (
    <div>
      <Router>
        <Navbar />
        <LoadingBar color="#f11946" progress={progress} />

        <Routes>
          <Route
            path="/"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={""}
              />
            }
          />
          <Route
            path="/business"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"business"}
              />
            }
          />
          <Route
            path="/entertainment"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"business"}
              />
            }
          />
          <Route
            path="/world"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"world"}
              />
            }
          />
          <Route
            path="/science"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"science"}
              />
            }
          />
          <Route
            path="/sports"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"sports"}
              />
            }
          />
          <Route
            path="/cryptocurrency"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={"cryptocurrency"}
              />
            }
          />
          <Route
            path="/general"
            element={
              <News
                setProgress={setProgress}
                apiKey={apiKey}
                pageSize={4}
                country={"in"}
                category={""}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
